<script setup lang="ts">
import ErrorNotification from '@/components/ErrorNotification.vue'
import { useAppVersionMonitor } from '@/composables/useAppVersionMonitor'

const { showUpdateBanner, wasAutoUpdated, reloadForUpdate } = useAppVersionMonitor()
const showUpdateAvailableNotice = ref(false)
const showAutoUpdatedNotice = ref(false)

watch(showUpdateBanner, (show) => {
  if (show) {
    showUpdateAvailableNotice.value = true
  }
})

watch(wasAutoUpdated, (updated) => {
  if (updated) {
    showAutoUpdatedNotice.value = true
  }
})
</script>

<template>
  <VApp>
    <ErrorNotification />
    <VSnackbar
      v-model="showUpdateAvailableNotice"
      color="info"
      location="top center"
      timeout="-1"
      variant="tonal"
    >
      <template #text>
        A new version of OrbViz is available.
      </template>
      <template #actions>
        <VBtn variant="text" @click="reloadForUpdate">Refresh now</VBtn>
      </template>
    </VSnackbar>
    <VSnackbar
      v-model="showAutoUpdatedNotice"
      color="info"
      location="top center"
      timeout="8000"
    >
      OrbViz refreshed to the latest version.
    </VSnackbar>
    <RouterView />
  </VApp>
</template>
